import axios, { type AxiosInstance } from "axios"
import config from "config"
import type {
  ICreateTrainingModule,
  ITrainingModule,
  IUpdateTrainingModule,
} from "types/trainingModuleTypes"

import authService from "./authService"

class TrainingModuleService {
  private http: AxiosInstance

  public constructor() {
    this.http = axios.create({
      baseURL: config.apiUrl,
      headers: {
        "Content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    })
  }

  public createTrainingModule = async (
    createTrainingModule: ICreateTrainingModule,
  ): Promise<ITrainingModule> => {
    const accessToken = await authService.getAccessToken()

    var bodyFormData = new FormData()
    bodyFormData.append("name", createTrainingModule.name)
    bodyFormData.append("id", createTrainingModule.id)
    bodyFormData.append("description", createTrainingModule.description)
    bodyFormData.append("simulatorApplicationId", createTrainingModule.simulatorApplicationId)
    bodyFormData.append("imageFile", createTrainingModule.imageFile)

    const { data } = await axios({
      method: "post",
      baseURL: config.apiUrl,
      url: "/trainingmodule",
      data: bodyFormData,
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${accessToken}`,
      },
    })

    return data
  }

  public getTrainingModules = async (): Promise<Array<ITrainingModule>> => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const { data } = await this.http.get<Array<ITrainingModule>>("/trainingmodule", config)

    return data
  }

  public getTrainingModule = async (id: string): Promise<ITrainingModule> => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const { data } = await this.http.get<ITrainingModule>(`/trainingmodule/${id}`, config)

    return data
  }

  public getSimulatorApplicationsTrainingModules = async (
    appId: string,
  ): Promise<Array<ITrainingModule>> => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const { data } = await this.http.get<Array<ITrainingModule>>(
      `/simulatorapplication/${appId}/trainingmodule`,
      config,
    )

    return data
  }

  public updateTrainingModule = async (
    trainingModuleId: string,
    updateTrainingModule: IUpdateTrainingModule,
  ): Promise<ITrainingModule> => {
    const accessToken = await authService.getAccessToken()

    var bodyFormData = new FormData()
    bodyFormData.append("name", updateTrainingModule.name)
    bodyFormData.append("description", updateTrainingModule.description)
    bodyFormData.append("simulatorApplicationId", updateTrainingModule.simulatorId)

    if (updateTrainingModule.imageFile !== undefined) {
      bodyFormData.append("imageFile", updateTrainingModule.imageFile)
    }

    const { data } = await axios({
      method: "put",
      baseURL: config.apiUrl,
      url: `/trainingmodule/${trainingModuleId}`,
      data: bodyFormData,
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${accessToken}`,
      },
    })

    return data
  }

  public deleteTrainingModule = async (trainingModuleId: string) => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const resp = await this.http.delete(`/trainingmodule/${trainingModuleId}`, config)

    return resp
  }
}

const trainingModuleService = new TrainingModuleService()

export default trainingModuleService
